module.exports = __webpack_public_path__ + "img/iconemapa2.d83369d2.png";